import { render, staticRenderFns } from "./TaskRelationModal.vue?vue&type=template&id=4455b8ac&scoped=true"
import script from "./TaskRelationModal.vue?vue&type=script&lang=js"
export * from "./TaskRelationModal.vue?vue&type=script&lang=js"
import style0 from "./TaskRelationModal.vue?vue&type=style&index=0&id=4455b8ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4455b8ac",
  null
  
)

export default component.exports